import { z } from 'zod'

export const setupCheckItem = z.object({
    key: z.string(),
    ok: z.boolean(),
    code: z.string(),
    meta: z
        .object({
            permissions: z.string().array().optional(),
        })
        .optional(),
})

export const setupCheckResult = z.object({
    ok: z.boolean(),
    checks: setupCheckItem.array(),
})

export type SetupCheckResult = z.infer<typeof setupCheckResult>
